export default __webpack_public_path__ + "Quality-Standards-Leaf-Icon.9845ae75.jpg";